export default __webpack_public_path__ + "static/media/vivo_five.126b89a9.webp";